import { getV1 } from '@/common/utils/ajax'
import { DEFAULT_PER } from '@/config'

const getRealTiemData = (params) => {
    return getV1(`house_businesses`, params)
}

const getHistory = (lastDay) => {
    return getV1(`house_businesses/histories`, { last_days: lastDay })
}

const beikeSecondhandMonthlyPrices = (params) => {
    return getV1(`beike_secondhand_monthly_prices`, params)
}

const getTrends = (step = 'weekly') => {
    return getV1(`house_businesses/trends`, {
        daterange_step: step
    })
}

const buildingWeeklyReports = (params) => {
    return getV1(`building_weekly_reports`, params)
}

const getLandTrades = (params) => {
    return getV1(`land_trades`, {
        per: DEFAULT_PER,
        ...params
    })
}

const getLandTradesDetail = (id) => {
    return getV1(`land_trades/${id}`)
}

const getTradeLandMap = () => {
    return getV1('land_trade_maps')
}

const getMapZones = () => {
    return getV1('land_trades/map_zones')
}

const getMapLands = (data) => {
    return getV1('land_trades/map_lands', data)
}
export default {
    getRealTiemData,
    getHistory,
    beikeSecondhandMonthlyPrices,
    getTrends,
    buildingWeeklyReports,
    getLandTrades,
    getTradeLandMap,
    getMapZones,
    getMapLands,
    getLandTradesDetail
}
